// components/NavBar.jsx
import React from 'react';

export default function NavBar() {
  return (
    <nav className="bg-green-700 text-white text-sm flex justify-center space-x-6 py-3">
      <a href="#">INÍCIO</a>
      <a href="#">A SECRETARIA</a>
      <a href="#">SERVIÇOS</a>
      <a href="#">UNIDADES</a>
      <a href="#">TRANSPARÊNCIA</a>
      <a href="#">CONTATO</a>
    </nav>
  );
}